(function () {
	'use strict';

	angular.module('changePasswordModule', ['ui.bootstrap', 'pascalprecht.translate', 'angularutilities', 'smarttableutilities'])
		.controller('changePasswordCtrl', ChangePasswordCtrl);

	function ChangePasswordCtrl($scope, $timeout, $http, $location, $uibPosition, $sce) {

		$scope.firstLogin = 'firstlogon' in $location.search();
		$scope.showExtraStrengthInfo = false;
		$scope.passwordProblemType = true;
		$scope.newPassword = '';
		$scope.confirmNewPassword = '';
		$scope.currentPasswordError = false;
		$scope.expireSession = false;
		$scope.passwordFieldTypes = {
			current: 'password',
			new: 'password',
			confirm: 'password'
		};

		$scope.submit = submit;
		$scope.toggleFieldType = toggleFieldType;

		$scope.$watch('currentPassword', function (newValue, oldValue) {
			if (newValue !== oldValue) {
				$scope.currentPasswordError = false;
			}
		});

		var passwordUtils = new PasswordUtils();
		$scope.$watch('newPassword', function() {
			passwordUtils.checkStrength($scope, $sce);
		});
		var checkRequirements = passwordUtils.checkRequirements.bind(null, $scope);
		checkRequirements();
		$scope.$watch('confirmNewPassword', checkRequirements);

		$timeout(function(){
			jQuery('li.list-group-item.selected').removeClass('selected');
			jQuery('#myAccountChangePassword').addClass('selected');
			jQuery('#currentPassword').focus();
			if ($scope.firstLogin) {
				jQuery('#sidebarCell').hide();
				$scope.displayTabs.active = false;
				jQuery('.embeddedBody').css('margin-left', '16px');
			}
		}, 0);

		$scope.clearToast = function() {
			$scope.toastMessage = undefined;
		};

		function toggleFieldType(field) {
			var newValue = $scope.passwordFieldTypes[field] === 'password' ? 'text' : 'password';
			$scope.passwordFieldTypes[field] = newValue;
		}

		function processResponse (response) {
			$scope.toastMessage = response.data.message;
			if ($scope.expireSession) {
				setTimeout(function() {
					window.location.replace('/auth/1/login');
				}, 2000);
			}
			if ($scope.firstLogin && $scope.toastMessage === 'Password Changed') {
				// http://tosbourn.com/a-fix-for-window-location-origin-in-internet-explorer/
				if (!window.location.origin) {
					window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
				}
				setTimeout(function() {
					window.location.replace(window.location.origin + response.data.redirectUrl);
				}, 2000);
			} else if ($scope.toastMessage === 'Account Locked') {
				setTimeout(function() {
					window.location.replace('/login');
				}, 2000);
			}
			if ($scope.toastMessage === 'Incorrect Password') {
				$scope.currentPasswordError = true;
			} else {
				$scope.currentPassword = '';
				$scope.newPassword = '';
				$scope.confirmNewPassword = '';
			}
			$timeout(function() {
				$scope.toastMessage = '';
			}, 3000);
			jQuery('#currentPassword').focus().select();
		}

		function submit() {
			passwordUtils.checkStrength($scope, $sce);
			checkRequirements();
			if (!$scope.usernameLoaded) {
				$scope.toastMessage = 'Error loading user profile';
				$scope.errorToast = true;
				return;
			}
			$http.post(
				'/api/2/ChangePassword',
				{
					'currentPassword': encodeURIComponent($scope.currentPassword),
					'newPassword': encodeURIComponent($scope.newPassword),
					'dirFactoryNdx': globalConfig.factory.id,
					'clearUserSession': $scope.expireSession === true
				})
				.then(processResponse)
				.catch(processResponse);
		}
	}
})();
